import E11 from "modules/ebiForms/definitions/E11";
import E12 from "modules/ebiForms/definitions/E12";
import F1 from "modules/ebiForms/definitions/F1";
import F2 from "modules/ebiForms/definitions/F2";
import F3 from "modules/ebiForms/definitions/F3";
import F4 from "modules/ebiForms/definitions/F4";
import F5 from "modules/ebiForms/definitions/F5";
import F6 from "modules/ebiForms/definitions/F6";
import F7 from "modules/ebiForms/definitions/F7";
import F8 from "modules/ebiForms/definitions/F8";
import { IEbiFormDefinition } from "modules/ebiForms/typings";

/** Komunikacja i budownictwo: F1–F8, E11, E12 (docs/magistrat/ebi-wnioski). */
const FORMS: IEbiFormDefinition[] = [F1, F2, F3, F4, F5, F6, F7, F8, E11, E12];

export default FORMS;
